<template>
  <div>
    <b-modal
      :id="`modal-qrcode-form`"
      :title="modalTitle"
      :hideHeaderClose="isSubmitted"
      size="md"
      noFade
      noCloseOnBackdrop
    >
      <QRCodeForm
        :form.sync="form"
        :isSubmitted="isSubmitted"
        :branches="branches"
        :posSessions="posSessions"
        :disabled="formType === 'edit'"
        :defaultValues="defaultValues"
      />
      <template #modal-footer="{ ok, cancel, hide }">
        <template v-if="formType === 'create'">
          <BaseButton
            v-if="isSubmitted"
            className="btn-sm btn-web"
            disabled>
            <i class="fas fa-spinner spin"/>
          </BaseButton>
          <BaseButton
            v-else
            :text="$t('button.save')"
            :disabled="disabledSubmitButton"
            className="btn-sm btn-web"
            @click="() => handleSubmit(ok)"/>
        </template>
        <template v-else>
          <BaseButton
            v-if="formType === 'create'"
            :text="$t('button.close')"
            className="btn-sm btn-light"
            @click="ok"/>
          <div
            v-else
            class="d-flex justify-content-between w-100">
            <BaseButton
              :text="$t('button.delete')"
              :disabled="isSubmitted"
              className="btn-sm btn-danger"
              @click="() => handleDelete(ok)"/>
            <BaseButton
              :text="$t('button.close')"
              :disabled="isSubmitted"
              className="btn-sm btn-light"
              @click="ok"/>
          </div>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import QRCodeForm from '../combine/QRCodeForm.vue'

export default {
  props: {
    formType: {
      type: String,
      default: 'create', // create, edit
    },
    isSubmitted: Boolean,
    branches: Array,
    posSessions: Array,
    defaultValues: Object,
    modalTitle: String,
    qrcode: Object, // required if 'formType' is 'create'
  },

  components: {
    QRCodeForm,
  },

  data () {
    return {
      form: {},
    }
  },

  computed: {
    isInvalidPosSession() {
      if (this.form.qrcodeType === 'one_time_use' && !this.form.psId) {
        return true
      }
      return false
    },
    disabledSubmitButton() {
      if (this.form.qrcodeType === 'one_time_use') {
        if (this.isInvalidPosSession) {
          return true
        }
      }
      if (this.form.table == null) {
        return true
      }
      return false
    },
  },

  methods: {
    handleSubmit(ok) {
      this.$emit('onSubmit', {
        form: this.form,
        ok,
      })
    },
    handleDelete(ok) {
      this.$emit('onDelete', {
        qrcode: this.qrcode,
        ok,
      })
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseBModalQRCodeForm.vue